"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'domp... Remove this comment to see the full error message
const dompurify_1 = __importDefault(require("dompurify"));
const Helper_1 = require("../../Helper");
const MessageTemplate_1 = require("./MessageTemplate");
class Message {
    constructor(_options, _container) {
        this.message = null;
        this.container = _container;
        this.options = _options;
        this.initialize();
        this.setupEventListeners();
    }
    initialize() {
        const milliseconds = Date.now();
        const timestamp = Math.floor(milliseconds / 1000);
        const { title, message, type, closeButton } = this.options;
        const htmlSafeTitle = dompurify_1.default.sanitize(title);
        const htmlSafeMessage = dompurify_1.default.sanitize(message);
        const messageMarkup = (0, MessageTemplate_1.messageTemplate)(type, htmlSafeTitle, htmlSafeMessage, closeButton);
        const messageElementWrapper = document.createElement("div");
        messageElementWrapper.innerHTML = messageMarkup;
        const messageElement = messageElementWrapper.firstElementChild;
        messageElement.id = "neos-notification-message-" + timestamp;
        this.message = messageElement;
        this.container.appendChild(messageElement);
        this.registerCloseButton(messageElement);
        this.registerExpandHandling(messageElement);
    }
    registerExpandHandling(message) {
        const contentSection = message.querySelector(".neos-notification-content");
        if (!(0, Helper_1.isNil)(contentSection) &&
            contentSection.classList.contains("expandable")) {
            contentSection.addEventListener("click", this.toggle.bind(this));
        }
    }
    registerCloseButton(message) {
        const closeButton = message.querySelector(".neos-close-button");
        if (!(0, Helper_1.isNil)(closeButton)) {
            closeButton.addEventListener("click", this.close.bind(this));
        }
    }
    setupEventListeners() {
        const timeout = this.options.timeout;
        if (timeout > 0) {
            setTimeout(this.close.bind(this), timeout);
        }
    }
    close() {
        if (!(0, Helper_1.isNil)(this.message)) {
            this.message.classList.add("fade-out");
            setTimeout(() => {
                this.message.remove();
            }, 250);
        }
    }
    toggle() {
        if ((0, Helper_1.isNil)(this.message)) {
            return;
        }
        const contentSection = this.message.querySelector(".neos-notification-content");
        if (!(0, Helper_1.isNil)(contentSection)) {
            contentSection.classList.toggle("expanded");
        }
    }
}
exports.default = Message;
